import { buildApiUrl } from '../config/api.js';

class SeasonService {
  constructor() {
    this.authenticatedFetch = null;
  }

  // Método para establecer la función de fetch autenticada
  setAuthenticatedFetch(fetchFn) {
    this.authenticatedFetch = fetchFn;
  }

  // Obtener todas las temporadas
  async getAllSeasons() {
    try {
      const url = buildApiUrl('/api/admin/seasons');
      console.log('🔍 seasonService.getAllSeasons:', { 
        url, 
        hasAuthenticatedFetch: !!this.authenticatedFetch,
        hasToken: !!localStorage.getItem('authToken')
      });
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        : await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
          });
      
      console.log('📡 seasonService.getAllSeasons response:', { 
        status: response.status, 
        ok: response.ok,
        statusText: response.statusText 
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al obtener temporadas:', error);
      throw error;
    }
  }

  // Obtener temporada por ID
  async getSeasonById(id) {
    try {
      const url = buildApiUrl(`/api/admin/seasons/${id}`);
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        : await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al obtener temporada:', error);
      throw error;
    }
  }

  // Crear nueva temporada
  async createSeason(seasonData) {
    try {
      const url = buildApiUrl('/api/admin/seasons');
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(seasonData)
          })
        : await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify(seasonData)
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al crear temporada:', error);
      throw error;
    }
  }

  // Actualizar temporada
  async updateSeason(id, seasonData) {
    try {
      const url = buildApiUrl(`/api/admin/seasons/${id}`);
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(seasonData)
          })
        : await fetch(url, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify(seasonData)
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al actualizar temporada:', error);
      throw error;
    }
  }

  // Eliminar temporada
  async deleteSeason(id, forceDelete = false) {
    try {
      const url = buildApiUrl(`/api/admin/seasons/${id}`);
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ forceDelete })
          })
        : await fetch(url, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify({ forceDelete })
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        
        // Si es un error 400 con elementos asociados, devolver la información completa
        if (response.status === 400 && errorData.hasAssociatedItems) {
          const error = new Error(`Error ${response.status}: ${errorData.error}`);
          error.status = response.status;
          error.data = errorData;
          throw error;
        }
        
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al eliminar temporada:', error);
      throw error;
    }
  }

  // Obtener temporada activa para una fecha
  async getActiveSeason(date) {
    try {
      const url = buildApiUrl(`/api/admin/seasons/active?date=${date}`);
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        : await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al obtener temporada activa:', error);
      throw error;
    }
  }
}

export default new SeasonService();
